import store from "@/store";
import {
  ref,
  reactive,
  onBeforeMount,
  onBeforeUnmount,
  getCurrentInstance,
  onMounted,
  watch,
  onUpdated,
} from "@vue/composition-api";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useFlatPickr from "@/utils/hooks/useFlatPickr";
import { dynamicTableModel } from "@/models/data-management/dynamic-table";
import useDynamicFields from "@/views/components/dynamic-fields/hooks/useDynamicFields";
import { dynamicReport } from "@/configs/dynamic-config/dynamic-report";

export default function useGenerateReportModal(props) {
  const vm = getCurrentInstance().proxy;
  const { openDefaultErrorModal } = useValidationModal();

  const { resolveFields, buildInformationPayload } = useDynamicFields();

  const form = reactive({
    status: null,
  });

  const filterOption = reactive({
    payload: [],
  });

  const isFilter = ref(false);
  const loading = reactive({ tableData: false, btnReport: false });

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateString,
    resolveDateObject,
  } = useFlatPickr();

  const { fetchQueryDisplayReportModel } = dynamicTableModel();

  const fetchDetail = () => {
    let selectOption = [];
    if (props) {
      form.status = props.customDataObj?.formStatus || 0;
      selectOption = props.customDataObj?.statusOption;
      fetchDynamicFilter(selectOption);
    }
  };

  const fetchDynamicFilter = (selectOption) => {
    let dateTimePicker = new Date();
    let nextDatePicker = new Date(dateTimePicker);
    nextDatePicker.setDate(dateTimePicker.getDate() + 1);
    nextDatePicker.toLocaleDateString();

    let startDateISO =
      dateTimePicker.getFullYear() +
      "-" +
      (dateTimePicker.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dateTimePicker.getDate() +
      " 00:00";

    let endDateISO =
      nextDatePicker.getFullYear() +
      "-" +
      (nextDatePicker.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      nextDatePicker.getDate() +
      " 00:00";

    try {
      dynamicReport.filters[0].value = startDateISO;
      dynamicReport.filters[1].value = endDateISO;
    } catch {}

    // default dynamic filter

    dynamicReport.filters[0].field_property.width = "auto";
    dynamicReport.filters[1].field_property.width = "auto";
    filterOption.payload = dynamicReport.filters;

    // get dynamic filter from api
    let selectKey = null;
    if (selectOption.length > 0) {
      selectKey = selectOption[form.status]?.obj.report_key;
    }

    if (!selectKey) return;

    fetchQueryDisplayReportModel.payload.Display_Key = selectKey;
    store
      .dispatch("api/apiRequest", fetchQueryDisplayReportModel)
      .then((resp) => {
        let respData = resp.data.dynamic_fields;
        respData.forEach((report) => (report.filters = dynamicReport.filters));

        if (respData.length > 0) {
          try {
            respData[0].value = startDateISO;
            respData[1].value = endDateISO;
          } catch {}

          respData[0].field_property.width = "auto";
          respData[1].field_property.width = "auto";
        } else {
          respData = [...dynamicReport.filters];
        }

        filterOption.payload = respData;
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {});
  };

  const onSubmit = async () => {
    const payload = await buildInformationPayload(filterOption.payload);

    vm.$emit("generateDefaultReport", {
      filterObj: payload,
    });
  };

  onBeforeMount(() => {
    fetchDetail();
  });

  watch(props, () => {
    fetchDetail();
  });

  return {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateString,
    resolveDateObject,
    form,
    loading,
    filterOption,
    resolveFields,
    onSubmit,
    isFilter,
  };
}
